import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { EncryptionService } from './encryption.service';
import { AppEnum } from '../appenum';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class AppNavigationService {
  componentName: string = 'app-navigation';

  constructor(
    private nav: NavController,
    private router: Router,
    public loggingService: LoggingService,
    private encryptionService: EncryptionService,
    private appEnum: AppEnum
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
  }

  private getTaskId(): string {
    try {
      return this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this.appEnum.EntityOfLocalStorageKeys.taskid
        )
      ) || '';
    } catch {
      return '';
    }
  }

  private buildExtras(extras?: NavigationExtras): NavigationExtras {
    const taskId = this.getTaskId();
    return {
      ...extras,
      queryParams: {
        taskId: taskId,
        ...extras?.queryParams
      }
    };
  }

  navigateForward(path: string | string[], extras?: NavigationExtras): void {
    this.nav.navigateForward(path, this.buildExtras(extras));
  }

  navigateBack(path: string | string[], extras?: NavigationExtras): void {
    this.nav.navigateBack(path, this.buildExtras(extras));
  }
  navigate(path: string[], extras?: NavigationExtras): void {
    this.router.navigate(path, this.buildExtras(extras));
  }

  navigateRoot(path: string | any[], extras?: NavigationExtras): void {
    const { cleanPath, routeParams } = this.extractRouteParams(path);

    const builtExtras = this.buildExtras(extras);

    if (Object.keys(routeParams).length > 0) {
      this.nav.navigateRoot([...cleanPath, routeParams], builtExtras);
    } else {
      this.nav.navigateRoot(cleanPath, builtExtras);
    }
  }

  private extractRouteParams(path: string | any[]): { cleanPath: string[], routeParams: object } {
    if (typeof path === 'string') {
      return { cleanPath: [path], routeParams: {} };
    }
    const cleanPath = path.filter(segment => typeof segment === 'string');
    const routeParams = path.find(segment => typeof segment === 'object') || {};

    return { cleanPath, routeParams };
  }
}
